/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyDto } from '../../models/agency-dto';

export interface ApiAgencyGet$Params {
  'api-version'?: string;
}

export function apiAgencyGet(http: HttpClient, rootUrl: string, params?: ApiAgencyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgencyDto>>;
    })
  );
}

apiAgencyGet.PATH = '/api/agency';
